import { render, staticRenderFns } from "./selectDesc.vue?vue&type=template&id=bf1cf4e6&scoped=true"
import script from "./selectDesc.vue?vue&type=script&lang=js"
export * from "./selectDesc.vue?vue&type=script&lang=js"
import style0 from "./selectDesc.vue?vue&type=style&index=0&id=bf1cf4e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1cf4e6",
  null
  
)

export default component.exports